import styled from "styled-components";

export const Wrapper = styled.p`
  font-size: 0.5em;
  text-decoration: underline;
  text-align: center;
  padding-bottom: 1em;
  cursor: pointer;
`;
